package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CustomHighlightRequest(
    val domainType: String,
    val emotions: String,
    val endTime: Double,
    val keywords: List<CustomKeyword>,
    val language: String,
    val organization: String,
    val sentiment: String,
    val sessionDateTimes: String,
    val sessionID: String,
    val sessionType: String,
    val startTime: Double,
    val tone: String,
    val totalTime: Double,
    val transcript: String,
    val notes: String,
    val type: String,
    val userID: String,
    val tagPlayers: List<String>,
    val tagCoaches: List<String>,
    val wordCount: Int,
    val seasonID: String
)

@Serializable
data class CustomKeyword(
    val domainType: String,
    val keyWordType: String,
    val keywordCategory: String,
    val language: String,
    val organization: String,
    val sessionDateTime: String,
    val sessionID: String,
    val text: String,
    val usageCount: Int,
    val userID: String
)
